import axiosInstance from "./axiosInstance";

const CustomerService = {
    getCustomers: async (page, rowsPerPage) => {
            const response = await axiosInstance.get("/api/customers?page=" + page + "&size=" + rowsPerPage);
            return response.data; // Assume the API returns customer data
    },
    createCustomer: async (newCustomer) => {
            const response = await axiosInstance.post("/api/customers", newCustomer);
            return response.data; // Returns the created customer data
    },

    getCustomer: async (id) => {
            const response = await axiosInstance.get("/api/customers/" + id);
            return response.data; // Returns the created customer data
    },

    updateCustomer: async (id, customerData) => {
            const response = await axiosInstance.put("/api/customers/" + id, customerData);
            return response.data; // Returns the created customer data
    },

    createContact: async (contactData) => {
            const response = await axiosInstance.post("/api/customer-contacts", contactData);
            return response.data; // Returns the created customer data
    },

    updateContact: async (id, contactData) => {
            const response = await axiosInstance.put("/api/customer-contacts/" + id, contactData);
            return response.data; // Returns the created customer data
    },
    deleteContact: async (id)  => {
            const response = await axiosInstance.delete("/api/customer-contacts/" + id);
            return response.data; // Returns the created customer data
    },

    deleteCustomer: async (id)  => {
            const response = await axiosInstance.delete("/api/customers/" + id);
            return response.data; // Returns the created customer data
    },

    getTopCustomersWithRevenue: async() => {
        const response = await axiosInstance.get("/api/customers/getTop5ByRevenue");
        return response.data;
    },

    countAllCustomers: async() => {
        const response = await axiosInstance.get("/api/customers/count");
        return response.data;
    },


    searchCustomers: async(requestData, page = 0, size = 10) => {
        return  await axiosInstance.post(`/api/customers/search?page=${page}&size=${size}`, requestData)
    },

    getCustomerInfo: async(customerId) => {
        const response = await axiosInstance.get(`/api/customers/${customerId}/info`);
        return response.data;
    },

    getContactsByCustomer: async(customerId) => {
        const response = await axiosInstance.get(`/api/customer-contacts/by-customer/${customerId}`);
        return response.data;
    },
};

export default CustomerService;
